import { AiAgents, AiTeamsImpactLang, CaseStudies, CrmNav, Departments, MondayDifference, Products, Security, Trust, Closer, Logos, CloserLlama, Gartner, TrustNav, VibeNav, Hp26Accelerate, Hp26Capabilities, Hp26Trust, Hp26Teams, Hp26Quote, Hp26Closure, Hp26CaseStudies, HeroJan26Fu1, MobileHp26Hero, MobileHp26Accelerate, MobileHp26AiProducts, MobileHp26Capabilities, MobileHp26Teams, MobileHp26Foundation, MobileHp26Closure, MobileHp26CaseStudies, HpAi26AiProducts, HpAi26AiPoweredProducts, HpAi26Vib, HpAi26Workforce, HpAi26Workflows, HpAi26AiAssistantV2, HpAi26DarkCards, Hp26SidekickV2, HpAi26AgentsV2 } from "devlink";
import Hp26CaseStudiesConfig from "../configs/hp26casestudies-config";
import Hp26ClosureConfig from "../configs/hp26closure-config";
import Hp26SidekickV2Config from "../configs/hp26sidekickv2-config";
import Hp26TeamsConfig from "../configs/hp26teams-config";
import Hp26TrustConfig from "../configs/hp26trust-config";
import HpAi26AiAssistantV2Config from "../configs/hpai26aiassistantv2-config";
import HpAi26AiPoweredProductsConfig from "../configs/hpai26aipoweredproducts-config";
import HpAi26AiProductsConfig from "../configs/hpai26aiproducts-config";
import HpAi26DarkCardsConfig from "../configs/hpai26darkcards-config";
import HpAi26VibConfig from "../configs/hpai26vib-config";
import HpAi26WorkflowsConfig from "../configs/hpai26workflows-config";
import HpAi26WorkforceConfig from "../configs/hpai26workforce-config";
import Hp26CaseStudiesDefaultProps from "../configs/default-props/hp26casestudies-default-props";
import Hp26ClosureDefaultProps from "../configs/default-props/hp26closure-default-props";
import Hp26SidekickV2DefaultProps from "../configs/default-props/hp26sidekickv2-default-props";
import Hp26TeamsDefaultProps from "../configs/default-props/hp26teams-default-props";
import Hp26TrustDefaultProps from "../configs/default-props/hp26trust-default-props";
import HpAi26AiAssistantV2DefaultProps from "../configs/default-props/hpai26aiassistantv2-default-props";
import HpAi26AiPoweredProductsDefaultProps from "../configs/default-props/hpai26aipoweredproducts-default-props";
import HpAi26AiProductsDefaultProps from "../configs/default-props/hpai26aiproducts-default-props";
import HpAi26DarkCardsDefaultProps from "../configs/default-props/hpai26darkcards-default-props";
import HpAi26VibDefaultProps from "../configs/default-props/hpai26vib-default-props";
import HpAi26WorkflowsDefaultProps from "../configs/default-props/hpai26workflows-default-props";
import HpAi26WorkforceDefaultProps from "../configs/default-props/hpai26workforce-default-props";
import HeroJan26Fu1Config from "../configs/herojan26fu1-config";
import HeroJan26Fu1DefaultProps from "../configs/default-props/herojan26fu1-default-props";
import AiAgentsConfig from "../configs/aiagents-config";
import AiTeamsImpactLangConfig from "../configs/aiteamsimpactlang-config";
import CaseStudiesConfig from "../configs/casestudies-config";
import CloserLlamaConfig from "../configs/closerllama-config";
import MondayDifferenceConfig from "../configs/mondaydifference-config";
import ProductsConfig from "../configs/products-config";
import SecurityConfig from "../configs/security-config";
import TrustConfig from "../configs/trust-config";
import DepartmentsConfig from "../configs/departments-config";
import DepartmentsDefaultProps from "../configs/default-props/departments-default-props";
import AiAgentsDefaultProps from "../configs/default-props/aiagents-default-props";
import AiTeamsImpactLangDefaultProps from "../configs/default-props/aiteamsimpactlang-default-props";
import CaseStudiesDefaultProps from "../configs/default-props/casestudies-default-props";
import CloserLlamaDefaultProps from "../configs/default-props/closerllama-default-props";
import MondayDifferenceDefaultProps from "../configs/default-props/mondaydifference-default-props";
import ProductsDefaultProps from "../configs/default-props/products-default-props";
import SecurityDefaultProps from "../configs/default-props/security-default-props";
import TrustDefaultProps from "../configs/default-props/trust-default-props";
import DevlinkMagicConfig from "../components/devlink-magic/devlink-magic-config";
import DevlinkMagicComponent from "../components/devlink-magic/devlink-magic-component";
import { component } from "e2e/cypress.config";
export const DEVLINK_COMPONENT_CONFIGS = {
    Products: {
        component: Products,
        props: ProductsConfig,
        defaultProps: ProductsDefaultProps
    },
    Departments: {
        component: Departments,
        props: DepartmentsConfig,
        defaultProps: DepartmentsDefaultProps
    },
    AiTeamsImpactLang: {
        component: AiTeamsImpactLang,
        props: AiTeamsImpactLangConfig,
        defaultProps: AiTeamsImpactLangDefaultProps
    },
    Trust: {
        component: Trust,
        props: TrustConfig,
        defaultProps: TrustDefaultProps
    },
    Security: {
        component: Security,
        props: SecurityConfig,
        defaultProps: SecurityDefaultProps
    },
    AiAgents: {
        component: AiAgents,
        props: AiAgentsConfig,
        defaultProps: AiAgentsDefaultProps
    },
    CaseStudies: {
        component: CaseStudies,
        props: CaseStudiesConfig,
        defaultProps: CaseStudiesDefaultProps
    },
    MondayDifference: {
        component: MondayDifference,
        props: MondayDifferenceConfig,
        defaultProps: MondayDifferenceDefaultProps
    },
    Closer: {
        component: Closer,
        props: {}
    },
    Logos: {
        component: Logos,
        props: {}
    },
    Magic: {
        component: DevlinkMagicComponent,
        props: DevlinkMagicConfig
    },
    CloserLlama: {
        component: CloserLlama,
        props: CloserLlamaConfig,
        defaultProps: CloserLlamaDefaultProps
    },
    CrmNav: {
        component: CrmNav,
        props: {}
    },
    Gartner: {
        component: Gartner,
        props: {}
    },
    TrustNav: {
        component: TrustNav,
        props: {}
    },
    VibeNav: {
        component: VibeNav,
        props: {}
    },
    Hp26Accelerate: {
        component: Hp26Accelerate,
        props: {}
    },
    Hp26Capabilities: {
        component: Hp26Capabilities,
        props: {}
    },
    Hp26Trust: {
        component: Hp26Trust,
        props: Hp26TrustConfig,
        defaultProps: Hp26TrustDefaultProps
    },
    Hp26Teams: {
        component: Hp26Teams,
        props: Hp26TeamsConfig,
        defaultProps: Hp26TeamsDefaultProps
    },
    Hp26Quote: {
        component: Hp26Quote,
        props: {}
    },
    Hp26Closure: {
        component: Hp26Closure,
        props: Hp26ClosureConfig,
        defaultProps: Hp26ClosureDefaultProps
    },
    Hp26CaseStudies: {
        component: Hp26CaseStudies,
        props: Hp26CaseStudiesConfig,
        defaultProps: Hp26CaseStudiesDefaultProps
    },
    HeroJan26Fu1: {
        component: HeroJan26Fu1,
        props: HeroJan26Fu1Config,
        defaultProps: HeroJan26Fu1DefaultProps
    },
    MobileHp26Hero: {
        component: MobileHp26Hero,
        props: {}
    },
    MobileHp26Accelerate: {
        component: MobileHp26Accelerate,
        props: {}
    },
    MobileHp26AiProducts: {
        component: MobileHp26AiProducts,
        props: {}
    },
    MobileHp26Capabilities: {
        component: MobileHp26Capabilities,
        props: {}
    },
    MobileHp26Teams: {
        component: MobileHp26Teams,
        props: {}
    },
    MobileHp26Foundation: {
        component: MobileHp26Foundation,
        props: {}
    },
    MobileHp26Closure: {
        component: MobileHp26Closure,
        props: {}
    },
    MobileHp26CaseStudies: {
        component: MobileHp26CaseStudies,
        props: {}
    },
    HpAi26AiProducts: {
        component: HpAi26AiProducts,
        props: HpAi26AiProductsConfig,
        defaultProps: HpAi26AiProductsDefaultProps
    },
    HpAi26AiPoweredProducts: {
        component: HpAi26AiPoweredProducts,
        props: HpAi26AiPoweredProductsConfig,
        defaultProps: HpAi26AiPoweredProductsDefaultProps
    },
    HpAi26Vib: {
        component: HpAi26Vib,
        props: HpAi26VibConfig,
        defaultProps: HpAi26VibDefaultProps
    },
    HpAi26Workforce: {
        component: HpAi26Workforce,
        props: HpAi26WorkforceConfig,
        defaultProps: HpAi26WorkforceDefaultProps
    },
    HpAi26Workflows: {
        component: HpAi26Workflows,
        props: HpAi26WorkflowsConfig,
        defaultProps: HpAi26WorkflowsDefaultProps
    },
    HpAi26AiAssistantV2: {
        component: HpAi26AiAssistantV2,
        props: HpAi26AiAssistantV2Config,
        defaultProps: HpAi26AiAssistantV2DefaultProps
    },
    HpAi26DarkCards: {
        component: HpAi26DarkCards,
        props: HpAi26DarkCardsConfig,
        defaultProps: HpAi26DarkCardsDefaultProps
    },
    Hp26SidekickV2: {
        component: Hp26SidekickV2,
        props: Hp26SidekickV2Config,
        defaultProps: Hp26SidekickV2DefaultProps
    },
    HpAi26AgentsV2: {
        component: HpAi26AgentsV2,
        props: {}
    }
};
